import { connect } from 'react-redux'
import { getPostDischarges24mList } from '../actions/actions-postdischarges'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import PostDischarges24m from '../views/PostDischarges/postdischarges24m'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    postdischarges: state.postdischargesR.dataList,
    programsAssigned: state.programsR.programsassignedtologin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getPostDischarges: loginID => {
      dispatch(getPostDischarges24mList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const PostDischarge24mListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostDischarges24m)
export default PostDischarge24mListContainer
